import { useTranslation } from '@tmsw/powerups.intl.hooks.use-translation';
import { useStore } from '@tmsw/powerups.store';
import { CTAButton } from '@tmsw/powerups.ui.buttons.cta-button';
// import useSoundEffects from '@tmsw/powerups.audio.hooks.use-sound-effects';  // TODO: prolly sound fx on this button;
import { SelectionButton } from '../../components/SelectionButton';
import type {
  GoToPrevPage,
  GoToNextPage,
} from '@tmsw/powerups.config.page.provider';
import { useState } from 'react';

import './SelectionPageContent.css';
import { HeaderH1 } from '../promo/HeaderH1';

export type SelectionPageContentProps = {
  goToPrevPage: GoToPrevPage;
  goToNextPage: GoToNextPage;
  parentNode: string;
};

export function SelectionPageContent(props: SelectionPageContentProps) {
  console.log('SelectionPageContent props', props);

  /* eslint-disable-next-line no-unused-vars */
  const { goToPrevPage, goToNextPage, parentNode } = props;

  const { __t } = useTranslation(parentNode);
  const bgImg = __t('backgrounds', 'GENERAL').main;
  const classPrefix = __t('classPrefix');
  // const entityStateKey = __t('entityStateKey');
  const entitySetStateKey = __t('entitySetStateKey');
  const entityType = __t('entityType');
  const entities = __t(entityType);
  const ctaButtons = __t('ctaButtonList.buttons');
  console.log('CTA BUTTONS', ctaButtons);
  const viewport = useStore((state) => state.viewport);
  // const entityValue = useStore((state) => state[entityStateKey]);
  const setTargetValue = useStore((state) => state[entitySetStateKey]);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const meaCharacters = entities.slice(0, 4);
  const entitiesList =
    __t('market', 'GENERAL') === 'mea' ? meaCharacters : entities;
  return (
    <section
      className={`selection-section ${classPrefix}-selection-section`}
      style={{
        backgroundImage: `url(${bgImg})`,
        backgroundSize: `cover`,
        height: `${viewport.height}px`,
      }}
    >
      <div className={`selection-wrapper ${classPrefix}-selection-wrapper`}>
        <HeaderH1 textValue={__t('h1')} />
        <nav className={`selection-nav ${classPrefix}-selection-nav`}>
          <ul
            className={`selection-list ${classPrefix}-selection-list selection-list--2-columns ${classPrefix}-selection-list--2-columns`}
          >
            {entitiesList.map((entity: any) => (
              <li
                key={entity.slug}
                className={`selection-list-item ${classPrefix}-selection-list-item`}
              >
                <SelectionButton
                  slug={entity.slug}
                  ariaLabel={entity.ariaLabel}
                  selectionImage={entity.imgSrc}
                  // selectionCard={entity.selectionCard}
                  setTargetValue={setTargetValue}
                  setIsButtonDisabled={setIsButtonDisabled}
                  goToNextPage={goToNextPage}
                />
              </li>
            ))}
          </ul>
        </nav>
        <ul className="cta-btn-list">
          {Array.isArray(ctaButtons) &&
            ctaButtons.map((ctaBtn: any) => {
              const handleClick =
                ctaBtn.buttonType === 'back' ? goToPrevPage : goToNextPage;
              return (
                <li key={ctaBtn.buttonType}>
                  <CTAButton
                    className="selection-cta-btn"
                    primary={ctaBtn.primary}
                    onClick={() => {
                      handleClick();
                    }}
                    intlKey={ctaBtn.buttonType}
                    parentNode="GENERAL"
                    disabled={ctaBtn.buttonType === 'next' && isButtonDisabled}
                  />
                </li>
              );
            })}
        </ul>
      </div>
    </section>
  );
}
